import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7065aa13"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "old-results" }
const _hoisted_2 = { class: "old-results__content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "old-results__title" }, "Результаты анализа", -1))
const _hoisted_4 = { class: "old-results__stone" }
const _hoisted_5 = { class: "old-results__percentage" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "old-results__text" }, "налёта", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "old-results__subtitle" }, "Риск заболеваний полости рта", -1))
const _hoisted_8 = { class: "old-results__legend" }
const _hoisted_9 = {
  key: 0,
  class: "old-results__status old-results__status--empty"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Средний:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "old-results__status-percentage" }, "11—30%", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "old-results__status old-results__status--empty"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Низкий", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "old-results__status-percentage" }, "до 10%", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]

import { computed, PropType } from 'vue'
import { OldResultAnalyzesType } from '@/shared/types'
import { RESULT_STATUS } from '@/shared/constants'


export default /*#__PURE__*/_defineComponent({
  props: {
  resultAnalyzes: Object as PropType<OldResultAnalyzesType>,
},
  setup(__props) {

const props = __props



const hygieneStatus = computed(() => {
  if (props.resultAnalyzes.index) {
    const totalHygieneValue =
      props.resultAnalyzes.index.day +
      props.resultAnalyzes.index.month +
      props.resultAnalyzes.index.week

    if (totalHygieneValue > 30) {
      return RESULT_STATUS.bad
    } else if (totalHygieneValue > 10) {
      return RESULT_STATUS.unsatisfactory
    } else {
      return RESULT_STATUS.good
    }
  }
})

const hygieneStatusText = computed(() => {
  if (hygieneStatus.value === RESULT_STATUS.unsatisfactory) {
    return 'неудовлетворительная'
  }

  if (hygieneStatus.value === RESULT_STATUS.good) {
    return 'хорошая'
  }

  return 'плохая'
})

const percentage = computed(
  () =>
    props.resultAnalyzes.index.week +
    props.resultAnalyzes.index.month +
    props.resultAnalyzes.index.day
)

return (_ctx: any,_cache: any) => {
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, " Наличие камня: " + _toDisplayString(__props.resultAnalyzes.stoneList[0]), 1),
      _createVNode(_component_el_row, { justify: "space-between" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 9 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_progress, {
                class: "old-results__progress",
                "text-inside": "",
                status: _unref(hygieneStatus),
                "stroke-width": 162,
                percentage: _unref(percentage)
              }, {
                default: _withCtx(({ percentage }) => [
                  _createElementVNode("p", _hoisted_5, _toDisplayString(percentage) + "%", 1),
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["status", "percentage"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 13 }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createElementVNode("div", {
                class: _normalizeClass(["old-results__status", {
              'old-results__status--unsatisfactory':
                _unref(hygieneStatus) === _unref(RESULT_STATUS).unsatisfactory,
              'old-results__status--good': _unref(hygieneStatus) === _unref(RESULT_STATUS).good,
            }])
              }, " Гигиена " + _toDisplayString(_unref(hygieneStatusText)), 3),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", null, _toDisplayString(__props.resultAnalyzes.index.month) + "% - за месяц", 1),
                _createElementVNode("p", null, _toDisplayString(__props.resultAnalyzes.index.week) + "% - за неделю", 1),
                _createElementVNode("p", null, _toDisplayString(__props.resultAnalyzes.index.day) + "% - за сутки", 1)
              ]),
              (_unref(hygieneStatus) !== _unref(RESULT_STATUS).unsatisfactory)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
                : _createCommentVNode("", true),
              (_unref(hygieneStatus) !== _unref(RESULT_STATUS).good)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})